import React from 'react';
import { Form, Select } from 'antd';
import { useLecturerCode } from 'hooks';
import { selectBoxFilterOption } from 'utils/form-utils';

interface FormItemProps {
  form: any;
  required: boolean;
}

const LecturerFormItem = ({form, required=false}: FormItemProps): React.ReactElement => {
  /* ======================================================
   * variables
   * ====================================================== */

  /* ======================================================
  * hooks
  * ====================================================== */
  const { lecturerCodeList } = useLecturerCode();  
  /* ======================================================
   * effects
   * ====================================================== */

  /* ======================================================
   * render items
   * ====================================================== */
  return (
    <>
      <Form.Item name="lecturer_srl" style={{ width:'140px', display: 'inline-block', marginRight: '5px' }}  rules={[{ required: required, message: '' }]}>
        <Select 
          style={{width:'100%' }} 
          placeholder={'강사'}
          virtual={false}
          showSearch={true} 
          options={lecturerCodeList}       
          optionFilterProp="label"     
          filterOption={selectBoxFilterOption}
        />                
      </Form.Item> 
    </>
  );
};

export default LecturerFormItem;
